import React from 'react';
import { Box, Typography, Button, Divider, IconButton, Drawer, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BUY_SELL_OPTIONS, ERROR_TRADE_OPTIONS } from './tradeHistoryFilters';

/**
 * Extra-filter panel: a bottom sheet on mobile, a side panel on desktop.
 * Edits go to the draft copy; nothing is applied until Apply is pressed.
 */
const TradeHistoryFilterDrawer = ({
  open,
  onClose,
  isMobile,
  draftExtraFilters,
  setDraftExtraFilter,
  onReset,
  onApply,
}) => (
      <Drawer
        anchor={isMobile ? 'bottom' : 'right'}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: isMobile ? '100%' : 350,
            borderRadius: isMobile ? '16px 16px 0 0' : 0,
            maxHeight: isMobile ? '90vh' : '100%',
          }
        }}
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          
          <Divider sx={{ mb: 3 }} />
          
          {/* Filter Content */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flex: 1, overflowY: 'auto' }}>
            
            {/* Extra Filters */}
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5 }}>Trade Filters</Typography>
              {/* The exchange is picked from the sub-tabs above the list. */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Buy/Sell</InputLabel>
                  <Select
                    value={draftExtraFilters.buySell}
                    label="Buy/Sell"
                    onChange={(e) => setDraftExtraFilter('buySell', e.target.value)}
                  >
                    {BUY_SELL_OPTIONS.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                <FormControl fullWidth size="small">
                  <InputLabel>Error Trades</InputLabel>
                  <Select
                    value={draftExtraFilters.isErrorTrade}
                    label="Error Trades"
                    onChange={(e) => setDraftExtraFilter('isErrorTrade', e.target.value)}
                  >
                    {ERROR_TRADE_OPTIONS.map((opt) => (
                      <MenuItem key={String(opt.value)} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
            
          </Box>
          
          {/* Footer actions */}
          <Box sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider', display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={onReset}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={onApply}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Drawer>
);

export default TradeHistoryFilterDrawer;
